/*
  Cesera Cookie-Consent (Runde 52)
  --------------------------------
  Bedient Shopifys Consent-API. Es gibt bewusst KEINEN eigenen Cookie und keinen
  eigenen Speicher: `Shopify.customerPrivacy.setTrackingConsent()` schreibt
  `_tracking_consent`, und genau den liest Shopify beim Blocken seiner Pixel.
  Ein Parallelspeicher waere eine zweite Quelle der Wahrheit.

  Vier Dinge, die hier Absicht sind:

  1. Scheitert die API, erscheint die Karte NICHT. Ein Banner, dessen Knoepfe die
     Wahl nicht speichern koennen, ist schlimmer als gar keins — es holt eine
     Einwilligung ein, die nirgends ankommt.
  2. `Escape` schliesst den Einstellungs-Dialog, nicht die Karte. Eine Karte, die
     sich wegdruecken laesst, erzeugt eine Nicht-Entscheidung, die wie eine
     Entscheidung aussieht.
  3. Der Wiederaufruf haengt am bestehenden Anker `#shopifyReshowConsentBanner`.
     Denselben benutzt Shopifys natives Banner — damit funktioniert der Footer-Link
     vor und nach der Umstellung, und ein delegierter Listener am `document` faengt
     ihn auch, wenn der Footer nachgeladen wird.
  4. Eingeblendet wird ueber einen erzwungenen Reflow (`void el.offsetWidth`), NICHT
     ueber `requestAnimationFrame`. Der Startzustand muss einmal berechnet worden sein,
     sonst setzt der Browser Start und Ziel im selben Frame und die Transition entfaellt.
     Der naheliegende Weg — zwei verschachtelte `requestAnimationFrame` — traegt hier
     nicht: in einem Tab mit `document.visibilityState === 'hidden'` feuert rAF
     ueberhaupt nicht. Die Karte haengt dann mit `hidden=false`, aber ohne `is-visible`
     unsichtbar im DOM. Live nachgewiesen. Der Reflow ist synchron und davon unabhaengig.
*/
(function () {
  'use strict';

  if (window.ceseraConsentBooted) return;
  window.ceseraConsentBooted = true;

  var card = document.querySelector('[data-cesera-consent]');
  var prefs = document.querySelector('[data-cesera-prefs]');
  if (!card || !prefs) return;

  var dialog = prefs.querySelector('.cesera-consent-prefs__dialog');
  var boxes = prefs.querySelectorAll('[data-consent-key]');
  var cardError = card.querySelector('[data-cesera-consent-error]');
  var prefsError = prefs.querySelector('[data-cesera-prefs-error]');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  var api = null;
  var apiFailed = false;
  var lastTrigger = null;

  /* ---- Consent-API ------------------------------------------------- */

  function withApi(onReady, onFail) {
    if (api) return onReady(api);
    if (apiFailed || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      if (onFail) onFail();
      return;
    }
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error || !window.Shopify.customerPrivacy) {
        apiFailed = true;
        if (onFail) onFail();
        return;
      }
      api = window.Shopify.customerPrivacy;
      onReady(api);
    });
  }

  /*
    Hat die Besucherin schon entschieden?

    ⚠️ `shouldShowBanner()` allein taugt dafuer NICHT. Live gemessen: nach einem
    erfolgreichen `setTrackingConsent` — die Wahl war ueber einen Seitenwechsel hinweg
    erhalten (`getTrackingConsent()` → "no", `userCanBeTracked()` → false) — stand
    `shouldShowBanner()` trotzdem weiter auf `true`. Die Karte waere damit bei jedem
    Seitenaufruf zurueckgekommen und haette die getroffene Entscheidung ignoriert.

    ⚠️ Die drei inhaltlichen Felder taugen ebenfalls nicht: `analytics`, `marketing` und
    `preferences` stehen schon VOR jeder Entscheidung auf "yes" — das ist der regionale
    Vorgabewert des Shops, keine Wahl (derselbe Befund, der die Vorauswahl-Falle in
    `openPrefs` erzeugt).

    Belastbar ist `sale_of_data`: vor der ersten Entscheidung liefert Shopify dort einen
    leeren String, danach "yes" oder "no". Das ist der einzige Wert, der zwischen
    „Vorgabe" und „Entscheidung" unterscheidet.
  */
  function hasDecision(cp) {
    if (!cp || typeof cp.currentVisitorConsent !== 'function') return false;
    var consent = cp.currentVisitorConsent() || {};
    return consent.sale_of_data === 'yes' || consent.sale_of_data === 'no';
  }

  function needsChoice() {
    if (!api) return false;
    if (hasDecision(api)) return false;
    // Gilt hier ueberhaupt eine Einwilligungspflicht? `getRegulation()` ist die stabile
    // Antwort darauf ("GDPR" in DE) — sie haengt, anders als `shouldShowBanner()`, nicht
    // daran, ob Shopifys eigenes Banner im Admin konfiguriert ist.
    var regulated = typeof api.getRegulation === 'function' ? !!api.getRegulation() : true;
    var shopWants = typeof api.shouldShowBanner === 'function' ? api.shouldShowBanner() : false;
    return regulated || shopWants;
  }

  function save(values, errorEl, onSaved) {
    withApi(function (cp) {
      cp.setTrackingConsent(
        {
          analytics: values.analytics,
          marketing: values.marketing,
          preferences: values.preferences,
          sale_of_data: false
        },
        function (result) {
          if (result && result.error) return showError(errorEl);
          hideError(errorEl);
          onSaved();
        }
      );
    }, function () {
      showError(errorEl);
    });
  }

  function showError(el) {
    if (el) el.hidden = false;
  }
  function hideError(el) {
    if (el) el.hidden = true;
  }

  /* ---- Sichtbarkeit ------------------------------------------------ */

  function reveal(el) {
    el.hidden = false;
    // Erzwingt die Berechnung des Startzustands, damit die Transition laeuft.
    // Siehe Kopfkommentar, Punkt 4 — `requestAnimationFrame` taugt dafuer nicht.
    void el.offsetWidth;
    el.classList.add('is-visible');
  }

  function conceal(el, done) {
    el.classList.remove('is-visible');
    var settled = false;
    function finish() {
      if (settled) return;
      settled = true;
      el.removeEventListener('transitionend', onEnd);
      el.hidden = true;
      if (done) done();
    }
    function onEnd(event) {
      if (event.target !== el) return;
      finish();
    }
    if (reduced.matches) return finish();
    el.addEventListener('transitionend', onEnd);
    // Sicherheitsnetz: feuert `transitionend` nicht (unterbrochene Transition,
    // Tab im Hintergrund), bleibt das Element sonst fuer immer im DOM stehen.
    window.setTimeout(finish, 800);
  }

  function showCard() {
    reveal(card);
    // Haelt den mobilen Sticky-ATC-Balken unten, solange die Karte steht —
    // zwei gestapelte Leisten auf einem 390-px-Schirm sind die schlechtere Wahl.
    document.body.classList.add('cesera-consent-visible');
  }

  function hideCard() {
    conceal(card);
    document.body.classList.remove('cesera-consent-visible');
  }

  /* ---- Einstellungs-Dialog ----------------------------------------- */

  function openPrefs(trigger) {
    lastTrigger = trigger || document.activeElement;
    hideCard();

    function open() {
      reveal(prefs);
      if (typeof trapFocus === 'function') {
        trapFocus(dialog, dialog.querySelector('[data-consent="save"]'));
      } else if (dialog) {
        dialog.focus();
      }
    }

    withApi(function (cp) {
      // ⚠️ `currentVisitorConsent()` taugt NICHT als Vorauswahl, solange noch keine
      // Entscheidung vorliegt. Live gemessen: ohne `_tracking_consent`-Cookie und bei
      // `shouldShowBanner() === true` liefert es trotzdem
      // `{analytics:"yes", marketing:"yes", preferences:"yes"}` — das ist der regionale
      // Vorgabezustand des Shops, keine Wahl der Besucherin. Wer daraus vorbelegt,
      // zeigt beim ersten Besuch drei gesetzte Haken und holt sich eine Einwilligung,
      // die niemand gegeben hat.
      var decided = hasDecision(cp);
      var current = decided ? cp.currentVisitorConsent() : {};
      Array.prototype.forEach.call(boxes, function (box) {
        box.checked = decided && current[box.dataset.consentKey] === 'yes';
      });
      open();
    }, open);
  }

  function closePrefs() {
    conceal(prefs, function () {
      // Wurde ohne Entscheidung geschlossen, muss die Karte zurueckkommen —
      // sonst ist die Einwilligung unbemerkt verschwunden.
      if (needsChoice()) showCard();
    });
    hideError(prefsError);
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(lastTrigger);
    } else if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
  }

  function prefsOpen() {
    return !prefs.hidden;
  }

  /* ---- Bedienung ---------------------------------------------------- */

  function readBoxes() {
    var values = { analytics: false, marketing: false, preferences: false };
    Array.prototype.forEach.call(boxes, function (box) {
      values[box.dataset.consentKey] = box.checked;
    });
    return values;
  }

  function closeAll() {
    if (prefsOpen()) {
      conceal(prefs);
      if (typeof removeTrapFocus === 'function') removeTrapFocus(lastTrigger);
    }
    hideCard();
  }

  /*
    Der Wiederaufruf laeuft in der CAPTURE-Phase und stoppt die Weitergabe.

    Grund, live beobachtet: solange Shopifys natives Banner aktiv ist, haengt an
    demselben Anker `#shopifyReshowConsentBanner` auch dessen eigener Listener. Ein Klick
    im Footer oeffnete dadurch ZWEI Dialoge uebereinander — und Shopifys Dialog zog den
    Fokus an sich (`document.activeElement` war `shopify-pc__prefs__header-close`).
    `preventDefault()` allein reicht nicht: der fremde Listener haengt ebenfalls am
    `document` und wurde frueher registriert, laeuft in der Bubble-Phase also VOR diesem.
    Capture + `stopPropagation` kommt ihm zuvor.
  */
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var reopen = target.closest('a[href="#shopifyReshowConsentBanner"], [data-cesera-consent-open]');
      if (!reopen) return;
      event.preventDefault();
      event.stopPropagation();
      openPrefs(reopen);
    },
    true
  );

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var closer = target.closest('[data-cesera-prefs-close]');
    if (closer && prefs.contains(closer)) {
      event.preventDefault();
      closePrefs();
      return;
    }

    var button = target.closest('[data-consent]');
    if (!button || (!card.contains(button) && !prefs.contains(button))) return;

    var action = button.getAttribute('data-consent');
    var errorEl = prefs.contains(button) ? prefsError : cardError;

    if (action === 'prefs') {
      openPrefs(button);
      return;
    }
    if (action === 'all') {
      save({ analytics: true, marketing: true, preferences: true }, errorEl, closeAll);
      return;
    }
    if (action === 'none') {
      save({ analytics: false, marketing: false, preferences: false }, errorEl, closeAll);
      return;
    }
    if (action === 'save') {
      save(readBoxes(), errorEl, closeAll);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !prefsOpen()) return;
    event.preventDefault();
    closePrefs();
  });

  /* ---- Start -------------------------------------------------------- */

  withApi(function () {
    if (!needsChoice()) return;
    // Kurze Verzoegerung, damit der Hero den ersten Eindruck behaelt.
    window.setTimeout(function () {
      if (!prefsOpen() && needsChoice()) showCard();
    }, 600);
  });
})();
